import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter, Card, Row } from 'reactstrap';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import {
  individual_column_style,
  individual_header_style,
  icon_column_style,
  individual_icon_header_style
} from 'assets/styles/table_custom_style';
import { toast } from 'react-toastify';
import UserService from '../../../../../../User/service';
import { FaUsers } from 'react-icons/fa6';
import { EVENTS_EMIT } from 'hooks/useSocketConversationChatTs';
import { useSocketConversationChatTs } from 'hooks/useSocketConversationChatTs';

import ServiceAuth from 'services/ServiceAUTH';
import ConfirmationModal from 'components/Modal/ConfirmationModal';

const NotificationModal = ({ users, altIcon }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { socketChatTS } = useSocketConversationChatTs();

  const userLogin = localStorage.getItem('login');
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  const [confirmationModal, setConfirmationModal] = useState({
    isOpen: false,
    message: '',
    action: null,
    user: null
  });

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const closeConfirmationModal = (state) => {
    const isBoolean = typeof state === 'boolean';
    setConfirmationModal((prev) => ({
      ...prev,
      isOpen: isBoolean ? state : false,
      user: isBoolean && state === false ? null : prev.user
    }));
  };

  const executeDisconnectUser = (user) => {
    const authService = new ServiceAuth('logout');
    authService
      .create({
        login: user,
        logoutType: 'logout_involuntario'
      })
      .then(() => {
        toast.success('Usuário desconectado com sucesso!', {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .catch(() => {
        toast.error('Erro ao desconectar o usuário.', {
          autoClose: 3000,
          closeOnClick: true
        });
      });

    socketChatTS.emit(EVENTS_EMIT.LOGOUT_AGENT_SYSTEM, { login: user });
  };

  const executeDisableUser = (user) => {
    UserService.changeActive(user, {
      active: false
    })
      .then(() => {
        toast.info('Usuário desabilitado com sucesso!', {
          autoClose: 3000,
          closeOnClick: true
        });
        socketChatTS.emit(EVENTS_EMIT.LOGOUT_AGENT_SYSTEM, { login: user });
      })
      .catch((err) => {
        toast.error(err.response.data.message || 'Ops algo errado aconteceu!', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const handleConfirmAction = () => {
    const { action, user } = confirmationModal;
    if (action === 'disconnect') {
      executeDisconnectUser(user);
    } else if (action === 'disable') {
      executeDisableUser(user);
    }
    closeConfirmationModal();
  };

  const disconnectUser = (user) => {
    setConfirmationModal({
      isOpen: true,
      message:
        'Tem certeza que deseja desconectar o atendente do sistema? Será necessário realizar o login novamente!',
      action: 'disconnect',
      user
    });
  };

  const disableUser = (user) => {
    setConfirmationModal({
      isOpen: true,
      message:
        'Tem certeza que deseja bloquear o atendente do sistema? Será necessário reativar o acesso!',
      action: 'disable',
      user
    });
  };

  return (
    <>
      {!altIcon ? (
        <Button
          color="success"
          title="Visualizar atendentes logados no sistema"
          outline
          size="sm"
          type="button"
          style={{ minHeight: '2rem' }}
          onClick={toggleModal}
        >
          Usuários Logados
        </Button>
      ) : (
        <FaUsers
          title="Visualizar atendentes logados no sistema"
          onClick={toggleModal}
          size={30}
          color={systemConfiguration.primary_color}
          style={{
            cursor: 'pointer',
            marginLeft: '10px'
          }}
        />
      )}

      <Modal
        className="modal-dialog-centered"
        size="lg"
        isOpen={isOpen}
        toggle={toggleModal}
      >
        <div className="modal-header">
          <h6 className="modal-title" id="modal-title-default">
            Usuários Logados
          </h6>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={toggleModal}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <ModalBody>
          <hr style={{ marginTop: '-30px' }} />

          {users.length > 0 && (
            <Row className="mt-3">
              <div className="col">
                <div className="card-wrapper">
                  <Card>
                    <ToolkitProvider
                      data={users}
                      keyField="login"
                      columns={[
                        {
                          dataField: 'name',
                          text: 'Nome',
                          sort: true,
                          style: individual_column_style,
                          headerStyle: individual_header_style
                        },
                        {
                          dataField: 'login',
                          text: 'Login',
                          sort: true,
                          style: individual_column_style,
                          headerStyle: individual_header_style
                        },
                        {
                          dataField: 'disconnect',
                          style: icon_column_style,
                          headerStyle: individual_icon_header_style,
                          text: 'Desconectar',
                          // eslint-disable-next-line react/display-name
                          formatter: (_, row) => {
                            return (
                              <Button
                                size="sm"
                                color="warning"
                                disabled={
                                  userLogin === row.login || row.login === 'adm'
                                    ? true
                                    : false
                                }
                                title="Desconectar usuário do sistema"
                                onClick={() => disconnectUser(row.login)}
                              >
                                <li className="fas fa-user-times"></li>
                              </Button>
                            );
                          }
                        },
                        {
                          dataField: 'block',
                          style: icon_column_style,
                          headerStyle: individual_icon_header_style,
                          text: 'Bloquear',
                          // eslint-disable-next-line react/display-name
                          formatter: (_, row) => {
                            return (
                              <Button
                                size="sm"
                                color="danger"
                                title="Bloquear usuário do sistema"
                                disabled={
                                  userLogin === row.login || row.login === 'adm'
                                    ? true
                                    : false
                                }
                                onClick={() => disableUser(row.login)}
                              >
                                <li className="fas fa-user-lock"></li>
                              </Button>
                            );
                          }
                        }
                      ]}
                    >
                      {(props) => (
                        <div className="py-4 table-responsive">
                          <BootstrapTable
                            {...props.baseProps}
                            bootstrap4={true}
                            bordered={false}
                            classes="align-items-center"
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </Card>
                </div>
              </div>
            </Row>
          )}
        </ModalBody>

        <ModalFooter>
          <Button
            color="danger"
            data-dismiss="modal"
            type="button"
            onClick={toggleModal}
            style={buttonStyle(systemConfiguration.cancelation_button_color)}
          >
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
      <ConfirmationModal
        isModalOpen={confirmationModal.isOpen}
        onModalToggle={closeConfirmationModal}
        message={confirmationModal.message}
        deleteResource={handleConfirmAction}
        idResource={confirmationModal.user}
      />
    </>
  );
};

export default NotificationModal;
